__turbopack_context__.v({
  "chip": "chip-field-module-scss-module__kD2AoG__chip",
  "chipSelected": "chip-field-module-scss-module__kD2AoG__chipSelected",
  "chips": "chip-field-module-scss-module__kD2AoG__chips",
  "field": "chip-field-module-scss-module__kD2AoG__field",
  "icon": "chip-field-module-scss-module__kD2AoG__icon",
  "label": "chip-field-module-scss-module__kD2AoG__label",
  "note": "chip-field-module-scss-module__kD2AoG__note",
  "text": "chip-field-module-scss-module__kD2AoG__text",
});
